<template>
  <Navbar :logo="logo" :alt="alt" />
  <router-view />
  <Footer />
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";

export default {
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      logo: "/img/logo.png",
      alt: "Make Your Burger",
    };
  },
};
</script>

<style>
* {
  font-family: Helvetica;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.main-container {
  margin: 50px;
  min-height: 250px;
}

h1 {
  color: #222;
  font-size: 42px;
  text-align: center;
  margin-bottom: 30px;
}
</style>
